import { Link } from 'react-router-dom';
import { SITE } from '@/mocks/site';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[560px] h-[88vh] md:h-[720px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=dark%20moody%20archive%20room%20filled%20with%20stacks%20of%20old%20photographs%20and%20vintage%20computer%20monitors%2C%20warm%20amber%20desk%20lamp%20light%2C%20floating%20dust%20particles%2C%20deep%20shadows%2C%20investigative%20cinematic%20atmosphere%2C%20muted%20brown%20and%20gold%20tones%2C%20editorial%20photography&width=1600&height=900&seq=hlkb-hero-01&orientation=landscape"
          alt="堆满旧照片与老式显示器的档案室，一束暖光打在工作台上"
          title="黑料百科考古档案室 - 冷门小众内容挖掘"
          className="w-full h-full object-cover object-center"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-background-50/80 via-background-50/70 to-background-50"></div>
      <div className="absolute inset-0 archive-grain opacity-30"></div>

      <div className="relative z-10 w-full h-full flex items-center px-4 md:px-8">
        <div className="w-full max-w-4xl mx-auto md:mx-0 md:pl-6 lg:pl-16 animate-rise">
          <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-primary-500/50 text-[11px] md:text-xs tracking-[0.24em] text-primary-400 bg-background-50/40 backdrop-blur-sm">
            <i className="ri-map-pin-2-line"></i>
            {SITE.tagline}
          </span>

          <h1 className="mt-6 font-heading text-3xl sm:text-4xl md:text-6xl leading-[1.15] text-foreground-950">
            黑料百科：把被删的、
            <br className="hidden sm:block" />
            尘封的网络记忆挖出来
          </h1>

          <p className="mt-6 max-w-2xl text-sm md:text-lg text-foreground-700 leading-relaxed">
            这里不追热点，只做考古。论坛深处的楼层、失效链接背后的页面、被清空的目录，
            我们一件件打捞上岸，按年份归档，标好编号。
          </p>

          <div className="mt-9 flex flex-col sm:flex-row gap-3">
            <Link
              to="/archive"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-archive-2-line text-base"></i>
              进入考古档案库
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-md border border-background-400/70 text-foreground-900 text-sm hover:border-primary-500 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
            >
              我们怎么挖掘
              <i className="ri-arrow-right-line text-base"></i>
            </Link>
          </div>

          <div className="mt-12 flex flex-wrap items-center gap-x-8 gap-y-3 text-xs text-foreground-600">
            <span className="flex items-center gap-2">
              <i className="ri-database-2-line text-primary-500 text-sm"></i>
              收录 12,860+ 条线索
            </span>
            <span className="flex items-center gap-2">
              <i className="ri-time-line text-primary-500 text-sm"></i>
              {SITE.since}
            </span>
            <span className="flex items-center gap-2">
              <i className="ri-shield-check-line text-primary-500 text-sm"></i>
              不涉及任何个人隐私
            </span>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 hidden md:flex flex-col items-center gap-2 text-foreground-600">
        <span className="text-[10px] tracking-[0.3em]">向下滚动</span>
        <i className="ri-arrow-down-line animate-bounce text-lg"></i>
      </div>
    </section>
  );
}